import { extend, override } from 'flarum/common/extend';
import Application from 'flarum/common/Application';
import coreFooter from './components/coreFooter';
import addMobileElement from './components/addMobileElement';
// 2026-07-30 (v0.4.7): MobileTab 整合已撤项 (Trello #393), 不再 m.mount(MobileTab)

export default function modifyApplication() {
  extend(Application.prototype, 'mount', () => {
    $("#header-navigation Navigation").off("mouseenter");
    $("#header-navigation Navigation").off("mouseleave");
    $(".DiscussionPage-list").off("mouseover");
    $(".DiscussionPage-list").off("mouseout");
    const footer = document.createElement('div');
    footer.className = "coreFooter";
    m.mount(document.body.getElementsByClassName("App-content")[0].appendChild(footer), coreFooter);
    const mEle = document.createElement('div');
    m.mount(document.body.appendChild(mEle), addMobileElement);
  });
}